import { FC, useState } from "react"
import { useTranslation } from "react-i18next"

import { Guid } from "@/types"
import { ISelectOption } from "components/Select/SelectSearch"
import ConfirmModal from "components/ConfirmModal/ConfirmModal"
import Select from "components/Select/Select"
import ValidationMessage from "components/ValidationMessage/ValidationMessage"
import toastMessages from "stores/toastMessages"

interface IReservationDocumentSelectCategoryModalProps {
    categoies: ISelectOption<Guid>[]
    onSelect(documentCategoryId: Guid): Promise<void>
    onClose(): void
}

const ReservationDocumentSelectCategoryModal: FC<IReservationDocumentSelectCategoryModalProps> = ({
    categoies,
    onSelect,
    onClose,
}) => {
    const { t } = useTranslation()
    const [selectedCategoryId, setSelectedCategoryId] = useState<Guid>()
    const [isSubmitted, setIsSubmitted] = useState(false)
    const [isSumitting, setIsSumitting] = useState(false)

    async function handleSave() {
        setIsSubmitted(true)
        if (!selectedCategoryId) return
        setIsSumitting(true)
        try {
            await onSelect(selectedCategoryId)
            onClose()
        } catch(e) {
            toastMessages.showSystemError()
            setIsSumitting(false)
        }
    }

    return (
        <ConfirmModal
            title={t('documents.selectCategory')}
            maxWidth="586px"
            onClose={onClose}
            onConfirm={handleSave}
            confirmButtonLabel={t('common.save')}
            isBusy={isSumitting}>
            <Select
                value={selectedCategoryId}
                options={categoies}
                onChange={option => setSelectedCategoryId(option?.value)}
                isInvalid={isSubmitted && !selectedCategoryId}
                isInModal
            />
            {isSubmitted && !selectedCategoryId &&
                <ValidationMessage>{t('validation.required')}</ValidationMessage>
            }
        </ConfirmModal>
    )
}

export default ReservationDocumentSelectCategoryModal
